// Base API URL configuration. Falls back to backend default dev port 3000.
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

export const STAGING_API_BASE_URL = import.meta.env.VITE_STAGING_API_BASE_URL || 'https://hms-be-1-0g3h.onrender.com';

export const RUNTIME_ENV = import.meta.env.VITE_RUNTIME_ENV || 'staging';

// Socket.IO URL configuration
export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || (RUNTIME_ENV === 'staging' ? STAGING_API_BASE_URL : API_BASE_URL);

